module.exports = {
  "dof-cell": {
    "height": "108",
    "position": "relative",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingLeft": "24",
    "paddingRight": "24",
    "backgroundColor": "#ffffff"
  },
  "active-cell": {
    "backgroundColor:active": "#f5f5f5"
  },
  "cell-margin": {
    "marginBottom": "24"
  },
  "cell-title": {
    "flex": 1
  },
  "cell-indent": {
    "paddingBottom": "30",
    "paddingTop": "30"
  },
  "has-desc": {
    "paddingBottom": "18",
    "paddingTop": "18"
  },
  "cell-top-border": {
    "borderTopColor": "#e2e2e2",
    "borderTopWidth": "1"
  },
  "cell-bottom-border": {
    "borderBottomColor": "#e2e2e2",
    "borderBottomWidth": "1"
  },
  "cell-label-text": {
    "fontSize": "30",
    "color": "#616C73",
    "width": "188",
    "marginRight": "10"
  },
  "right-text": {
    "fontSize": "24",
    "color": "#8E969B"
  },
  "cell-arrow-icon": {
    "width": "12",
    "height": "24",
    "position": "absolute",
    "right": "24"
  },
  "cell-content": {
    "color": "#1E2E37",
    "fontSize": "30",
    "lineHeight": "40"
  },
  "cell-desc-text": {
    "color": "#8E969B",
    "fontSize": "24",
    "lineHeight": "30",
    "marginTop": "42"
  },
  "item-img": {
    "width": "208",
    "height": "148",
    "marginRight": "24"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-de1a6028!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-item/index.vue
// module id = 552
// module chunks = 0 1